module.exports = __webpack_public_path__ + "static/img/demo-structor.d2caccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo-structor.png
// module id = SEvx
// module chunks = 0